<template>
  <div>
    <button @click="home" class="backButton">
      <i class="pi pi-arrow-circle-left"></i>
        <span style="position:relative; top:-3px;">{{ ' ' + $t("Common.WeekOverView") }}</span>
    </button>
  </div>
</template>
<script>
//TODO translations
export default {
  name: "WeekOverViewLink",
  methods: {
    home() {
      localStorage.removeItem("selectedWorkDay");
      return this.$router
        .push({
          name: "work-days",
          query: {
            //ts: new Date().getTime(),
            workDate: this.$route.query.workDate
          },
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
a:not([href]) {
  color: #019ee9 !important;
  text-decoration: underline;
}

.backButton {
    font-size: 1em;
    text-decoration: none;
    display: inline-block;
    padding: 5px 10px 2px 10px;
    position: relative;
    border: 1px solid #c3c3c3;
    border-radius: 20px;
    background-color: white;
}

.backButton:hover {
  background-color: #f0f0f0;
}
</style>
